import { sectionTitle } from '../Components/Home/Header_Utils/header_utils'

const PageIntroduction = ({title, details,bg ,color}) => {



    const background = bg? bg :`linear-gradient(
    90deg,
    rgba(77, 163, 75, 1) 0%,
    rgba(76, 161, 82, 1) 29%,
    rgba(72, 153, 98, 0.94) 72%,
    rgba(72, 151, 104, 1) 100%
  )`
    const colour = color? color: "#FFFFFF"
    const style= {
      color:colour,
    background: background,
    }
  return title && details? <div style={style}>{sectionTitle(title,details)}</div> : <h1>Empty Tag</h1>
  
  
  
  
}

export default PageIntroduction